import axios from "axios";
import Config from "./Config";

const { API_BASE_URL } = Config;

const headers = {
  "Content-Type": "application/json",
};

export const getOffers = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/coupon/${Config.getCountryId()}`, { headers });
    if (response.data.status === true) {
      return response.data.responseData;
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error fetching offers:', error);
    return [];
  }
};
 